import React from 'react';
import { Panel, PanelHeader, FormLayout, Input, FixedLayout, Button, HeaderButton, Div } from '@vkontakte/vkui';
import DefaultPanel from "../classes/DefaultPanel";
import { connect } from "react-redux";
import {getQRCode} from "../services/vk";
import {setPaySum} from "../store/bills/actions";


class PanelPay extends DefaultPanel {

    state = {
        isWrong: true,
        isMore3000: false,
        inputValue: '',
    };

	settings() {
		this.title = 'Платеж';
		this.hasBack = true;
        this.hasSwipe = true;
	}

	openPayProcess = () => {
	    if (!isNaN(this.props.paySum) && this.props.paySum !== '' && +this.props.paySum !== 0) {
            this.openPage('pay-process');
        }
    };

	pComponentWillMount = () => {
        this.props.dispatch(setPaySum(''));
    };

    pComponentDidMount = async() => {
        const input = document.getElementById('input-pay');
        input.focus();
    };

    changeSum = (e) => {
	    let num = e.target === undefined ? e : e.target.value;
        num = num.replace(/,/g, '.');

        const isWrong = !isNaN(num) && num !== '' && +num !== 0;

        const isMore3000 = (num > 3000);

        this.setState({ isMore3000, isWrong, inputValue: num});
	    this.props.dispatch(setPaySum(num));
    };

	renderPanel() {
		let lastSumButtons = [];
		let checkArrayIn = [];
		let i = 0;
		const maxButtons = 5;
		while (i < this.props.lastSum.length && lastSumButtons.length < maxButtons) {
			if (checkArrayIn.indexOf(this.props.lastSum[i]) === -1) {
				const sum = this.props.lastSum[i];
				lastSumButtons.push(<Button size='l' onClick={ () => this.changeSum(sum) }>{ sum }</Button>);
            	checkArrayIn.push(this.props.lastSum[i]);
			}
			i++;
		}

		return(
			<React.Fragment>
				<FormLayout>
					<Input
						className="huge-input"
						type="tel"
						step="0.01"
						inputMode="decimal"
						placeholder="0"
						value={ this.state.inputValue }
						onChange={ this.changeSum }
						id="input-pay"
						maxLength={ 10 }
					/>
				</FormLayout>
                <Div className={ "sum-error" + (!this.state.isWrong ? ' show' : '') }>Сумма введена неверно</Div>
                <Div className={ "sum-3000" + (this.state.isMore3000 ? ' show' : '') }>Покупатель должен выбрать QR-код для покупки на сумму более 3000 рублей в приложении ВКонтакте.</Div>
				<Div>
					<div className="template-buttons">
						{ lastSumButtons }
						<Button size='l' onClick={ () => this.changeSum('100.00') }>100</Button>
						<Button size='l' onClick={ () => this.changeSum('200.00') }>200</Button>
						<Button size='l' onClick={ () => this.changeSum('300.00') }>300</Button>
						<Button size='l' onClick={ () => this.changeSum('500.00') }>500</Button>
						<Button size='l' onClick={ () => this.changeSum('1000.00') }>1000</Button>
						<Button size='l' onClick={ () => this.changeSum('1500.00') }>1500</Button>
						<Button size='l' onClick={ () => this.changeSum('2000.00') }>2000</Button>
					</div>
				</Div>
				<FixedLayout vertical="bottom" className="fixed-bottom">
					<Button size='xl' onClick={ this.openPayProcess }>Считать QR-код</Button>
				</FixedLayout>
			</React.Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        paySum: state.bills.paySum,
		lastSum: state.bills.lastSum,
    };
}

export default connect(mapStateToProps)(PanelPay);


// WEBPACK FOOTER //
// ./src/js/panels/PanelPay.js